<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
      <section id="ngx-datatable-kitchen-sink">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">{{ 'MENU.DASHBOARD.payments' | translate }}</h4>
          </div>
          <div class="card-body">
            <p class="card-text">{{ 'MENU.DASHBOARD.payments_list' | translate }}</p>
          </div>
        </div>
  
        <div class="row d-flex justify-content-between">
          <div class="col-md-2 col-sm-12 mb-1 mb-md-0">
            <div class="form-group">
              <label for="itemsPerPage" style="margin-right:6px !important">{{ 'MENU.DASHBOARD.show' | translate }}</label>
              <div class="d-flex align-items-center">
                <select
                  id="itemsPerPage"
                  class="form-control form-control-sm"
                  [(ngModel)]="itemsPerPage"
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <span class="mx-1">{{ 'MENU.DASHBOARD.entries' | translate }}</span>
              </div>
            </div>
          </div>
          <!-- <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="searchInput" class="mr-2">{{ 'MENU.DASHBOARD.search' | translate }}</label>
              <input
                id="searchInput"
                type="search"
                placeholder="{{ 'MENU.DASHBOARD.search' | translate }}"
                class="form-control form-control-sm"
                (keyup)="filterUpdate($event)"
                (search)="filterUpdate($event)"
              />
            </div> 
          </div> -->
        </div>
  
        <ngx-datatable 
          [rows]="paymentsData"
          [rowHeight]="58"
          class="bootstrap core-bootstrap bg-white"
          [limit]="itemsPerPage"
          [columnMode]="ColumnMode.force"
          [headerHeight]="40"
          [footerHeight]="50"
          [scrollbarH]="true"
          [messages]="messages"
        >
          <!-- رقم الإيصال -->
          <ngx-datatable-column
            name="{{ 'MENU.DASHBOARD.receipt_number' | translate }}"
            prop="receipt_number"
            [width]="150"
          ></ngx-datatable-column>

          <!-- رقم العقد -->
          <ngx-datatable-column
            name="{{ 'MENU.DASHBOARD.contract_number' | translate }}"
            prop="contract_number"
            [width]="200"
          ></ngx-datatable-column>

          <!-- تاريخ الدفعة -->
          <ngx-datatable-column name="{{ 'MENU.DASHBOARD.payment_date' | translate }}" [width]="180">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div>
                <div>{{ row.payment_date }}</div>
                <small class="text-muted">{{ row.payment_date_hijri }}</small>
              </div>
            </ng-template>
          </ngx-datatable-column>

          <!-- المبلغ -->
          <ngx-datatable-column name="{{ 'MENU.DASHBOARD.amount' | translate }}" [width]="150">
            <ng-template ngx-datatable-cell-template let-row="row">
              {{ row.payment?.paid_amount }} {{ 'MENU.DASHBOARD.Rs' | translate }}
            </ng-template>
          </ngx-datatable-column>

          <!-- المستثمر -->
          <ngx-datatable-column name="{{ 'MENU.DASHBOARD.investor' | translate }}" [width]="200">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div>
                <div>{{ row.investor?.name }}</div>
                <small class="text-muted">{{ row.investor?.email }}</small>
              </div>
            </ng-template>
          </ngx-datatable-column>

          <!-- طريقة الدفع -->
          <ngx-datatable-column name="{{ 'MENU.DASHBOARD.payment_method' | translate }}" [width]="150">
            <ng-template ngx-datatable-cell-template let-row="row">
              {{ row.payment?.payment_method }}
            </ng-template>
          </ngx-datatable-column>

          <!-- صورة التحويل -->
          <!-- <ngx-datatable-column name="{{ 'MENU.DASHBOARD.transfer_image' | translate }}" [width]="150">
            <ng-template ngx-datatable-cell-template let-row="row">
              <ng-container *ngIf="row.payment?.transfer_image; else noImage">
                <a 
                  [href]="row.payment.transfer_image" 
                  target="_blank" 
                  class="text-primary text-decoration-underline"
                >
                  {{ 'MENU.DASHBOARD.view_image' | translate }}
                </a>
              </ng-container>
              <ng-template #noImage>
                <span class="text-muted">-</span>
              </ng-template>
            </ng-template>
          </ngx-datatable-column> -->


          <!-- <ngx-datatable-column
  name="{{ 'MENU.DASHBOARD.transfer_image' | translate }}"
  [width]="160"
>
  <ng-template ngx-datatable-cell-template let-row="row">

    <ng-container *ngIf="row.payment?.transfer_image; else pdfOnly">
      <a
        [href]="row.payment.transfer_image"
        target="_blank"
        class="text-primary text-decoration-underline"
      >
        {{ 'MENU.DASHBOARD.view_image' | translate }}
      </a>
    </ng-container>

    <ng-template #pdfOnly>
      <span class="text-muted d-flex align-items-center gap-1">
        <i class="fas fa-file-pdf text-danger"></i>
        {{ 'MENU.DASHBOARD.pdf_file' | translate }}
      </span>
    </ng-template>

  </ng-template>
</ngx-datatable-column> -->


<ngx-datatable-column
  [name]="'MENU.DASHBOARD.transfer_file' | translate"
  [width]="180"
>
  <ng-template ngx-datatable-cell-template let-row="row">

    <ng-container *ngIf="row.payment?.transfer_image; else noFile">

      <!-- Detect file type -->
      <ng-container *ngIf="isPdf(row.payment.transfer_image); else imageFile">

        <!-- PDF -->
        <a
          [href]="row.payment.transfer_image"
          target="_blank"
          class="btn btn-sm btn-light-danger"
        >
          <i class="fas fa-file-pdf mr-1"></i>
          {{ 'MENU.DASHBOARD.view_pdf' | translate }}
        </a>

      </ng-container>

      <!-- IMAGE -->
      <ng-template #imageFile>
        <a
          [href]="row.payment.transfer_image"
          target="_blank"
          class="btn btn-sm btn-light-primary"
        >
          <i class="fas fa-image mr-1"></i>
          {{ 'MENU.DASHBOARD.view_image' | translate }}
        </a>
      </ng-template>

    </ng-container>

    <!-- No file -->
    <ng-template #noFile>
      <span class="text-muted">
        <i class="fas fa-ban mr-1"></i>
        {{ 'MENU.DASHBOARD.no_file' | translate }}
      </span>
    </ng-template>

  </ng-template>
</ngx-datatable-column>


          <!-- الحالة -->
          <ngx-datatable-column name="{{ 'MENU.DASHBOARD.status' | translate }}" [width]="120">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span
                class="px-1 py-1 badge rounded-pill fw-semibold text-capitalize move"
                [ngStyle]="{
                  'background-color': row.status === 'paid' ? 'rgba(25, 135, 84, 0.1)' : 'rgba(220, 53, 69, 0.1)',
                  'color': row.status === 'paid' ? '#198754' : '#dc3545',
                  'border': '1px solid ' + (row.status === 'paid' ? '#198754' : '#dc3545')
                }"
              >
                <i
                  class="me-1"
                  [ngClass]="{
                    'bg-success': row.status === 'paid',
                    'bg-danger': row.status !== 'paid'
                  }"
                ></i>
                {{ row.status === 'paid' ? ('MENU.DASHBOARD.paid' | translate) : ('MENU.DASHBOARD.unpaid' | translate) }}
              </span>
            </ng-template>
          </ngx-datatable-column>

          <!-- الإجراءات -->
          <ngx-datatable-column name="{{ 'MENU.DASHBOARD.investor_actions' | translate }}" [flexGrow]="1" [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <div ngbDropdown container="body" class="btn-group">
                  <button
                    ngbDropdownToggle
                    type="button"
                    class="btn btn-sm btn-icon dropdown-toggle hide-arrow"
                    [id]="'dropdownActions_' + row.id"
                  >
                    <i data-feather="more-vertical"></i>
                  </button>

                  <div
                    ngbDropdownMenu
                    class="dropdown-menu dropdown-menu-right"
                    [attr.aria-labelledby]="'dropdownActions_' + row.id"
                  >
                    <!-- <button
                      class="dropdown-item w-100"
                      ngbDropdownItem
                      (click)="viewPaymentDetails(row.id)"
                    >
                      <i data-feather="eye" class="mr-50 mx-2"></i>
                      {{ 'MENU.DASHBOARD.view_details' | translate }}
                    </button> -->

                    <!-- <button
                      class="dropdown-item w-100"
                      ngbDropdownItem
                      (click)="downloadReceipt(row.id)"
                    >
                      <i data-feather="download" class="mr-50 mx-2"></i>
                      {{ 'MENU.DASHBOARD.download_receipt' | translate }}
                    </button> -->

 <button
  class="dropdown-item text-success w-100"
  ngbDropdownItem
  (click)="addPayment(row.id)"
>
  <i data-feather="dollar-sign" class="mr-50 mx-2"></i>
  {{ 'MENU.DASHBOARD.Add_Paid_Amount' | translate }}
</button>


<!-- Edit Date button -->
<!-- <button
  class="dropdown-item text-primary w-100"
  ngbDropdownItem
  (click)="openEditDateModal(row)"
>
  <i data-feather="calendar" class="mr-50 mx-2"></i>
  {{ 'MENU.DASHBOARD.Edit_Date' | translate }}
</button> -->



                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </section>
    </div>
  </div>


  <ng-template #paidAmountModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title fw-bold">
      {{ 'MENU.DASHBOARD.Add_Paid_Amount' | translate }}
    </h5>
    <button type="button" class="close" (click)="modal.dismiss()">
      &times;
    </button>
  </div>

<div class="modal-body">

  <!-- Paid Amount -->
  <div class="mb-3">
    <label class="form-label fw-semibold">
      {{ 'MENU.DASHBOARD.Paid_Amount' | translate }}
    </label>
    <input
      type="number"
      class="form-control"
      [(ngModel)]="paidAmount"
      min="1"
    />
  </div>

  <!-- Transfer Image -->
  <div class="mb-3">
    <label class="form-label fw-semibold">
      {{ 'MENU.DASHBOARD.Transfer_Image' | translate }}
    </label>
    <input
      type="file"
      class="form-control"
      accept="image/*"
      (change)="onTransferImageSelected($event)"
    />
  </div>

</div>


  <div class="modal-footer justify-content-end">
    <button class="btn btn-secondary" (click)="modal.dismiss()">
      {{ 'MENU.DASHBOARD.Cancel' | translate }}
    </button>

<button
  class="btn btn-success"
  (click)="submitPaidAmount()"
  [disabled]="!paidAmount || !transferImage"
>
  {{ 'MENU.DASHBOARD.Confirm' | translate }}
</button>
  </div>
</ng-template>



<ng-template #editDateModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title fw-bold">
      {{ 'MENU.DASHBOARD.Edit_Date' | translate }}
    </h5>
    <button type="button" class="close" (click)="modal.dismiss()">
      &times;
    </button>
  </div>

  <div class="modal-body">
    <div class="mb-3">
      <label class="form-label fw-semibold">
        {{ 'MENU.DASHBOARD.payment_date' | translate }}
      </label>

      <input
        type="date"
        class="form-control"
        [(ngModel)]="editPaymentDateValue"
      />
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="modal.dismiss()">
      {{ 'MENU.DASHBOARD.Cancel' | translate }}
    </button>

    <button
      class="btn btn-primary"
      (click)="submitEditDate()"
      [disabled]="!editPaymentDateValue"
    >
      {{ 'MENU.DASHBOARD.Confirm' | translate }}
    </button>
  </div>
</ng-template>
